import { getScrollContainer } from '@theme/scroll-container';

// -- Constants
const BUTTON_SELECTOR = '[data-darkrim-float-button-control]';
const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

class DarkrimFloatButton extends HTMLElement {
  #abortController = null;

  // -- Listeners
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button || !this.contains(button)) return;

    const scrollContainer = getScrollContainer();
    const targetTop =
      this.dataset.scrollTarget === 'bottom'
        ? Math.max(0, scrollContainer.scrollHeight - scrollContainer.clientHeight)
        : 0;
    const behavior =
      this.dataset.scrollBehavior === 'smooth' && !REDUCED_MOTION_QUERY.matches ? 'smooth' : 'auto';

    scrollContainer.scrollTo({ top: targetTop, left: 0, behavior });
  };

  // -- Lifecycle hooks
  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    this.addEventListener('click', this.#handleClick, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }
}

if (!customElements.get('darkrim-float-button')) {
  customElements.define('darkrim-float-button', DarkrimFloatButton);
}
